import { Component, Element, Host, Listen, Prop, State, Watch, h } from '@stencil/core';

const ArrowIcon = ():SVGElement => (
  <svg viewBox="0 0 12 8" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 1l5.07130435 5.29043478L11 1" stroke-width="1.5" fill="none" fill-rule="evenodd" stroke-linecap="round"/>
  </svg>
);

@Component({
  tag: 'zpr-navbar-dropdown',
  styleUrl: './navbar-dropdown.scss',
})

export class ZprNavbar {
  private _dropdownElement: HTMLZprDropdownElement;
  private _anchor: HTMLElement;

  private _trigger: HTMLElement

  @Element() el: HTMLElement;
  @Prop({reflect: true}) link: '#';
  @Prop({reflect: true}) buttonText: 'Dropdown';
  @Prop({reflect: true}) hasSubnav? = false;
  @Prop({reflect: true}) isOpenWithHover? = false;
  @State() isOpen: boolean = false;

  componentWillLoad(){
    this._anchor = document.querySelector('.desktop-navbar')
  }

  componentDidLoad() {
    const toggleEl = this._dropdownElement.querySelector('[slot="toggle"]');
    const bodyEl = this._dropdownElement.querySelector('[slot="body"]');

    if (this.isOpenWithHover) {
      toggleEl?.addEventListener('mouseover', (ev: Event) => {
        ev.preventDefault()
        this.resetOpenedDropdown()
        this._dropdownElement.open()
      })
      bodyEl?.addEventListener('mouseleave', (ev: Event) => {
        ev.preventDefault()
        this._dropdownElement.close()
      })
    }
  }

  @Listen('click', { target: 'window' })
  onBodyClick(ev: MouseEvent) {
    if (this._trigger.contains(ev.target as any) || this.el.contains(ev.target as any)) return
    this._dropdownElement.close()
    this.isOpen = false
  }

  resetOpenedDropdown() {
    const navbarDropdownElements =  document.querySelectorAll('zpr-dropdown');
    for(const dropdown of navbarDropdownElements){
      (dropdown as HTMLZprDropdownElement).close();
    }
  }

  toggle(){
    this.isOpen = !this.isOpen
    this._dropdownElement.toggle();
  }

  render() {
    return (
      <Host tabindex="0">
          <a href={this.link} ref={el=>this._trigger = el} class="btn btn-ghost btn-medium" onClick={()=>{
            this.toggle()
          }} aria-expanded="false" >
            { this.buttonText }
            <span class="arrow-icon" data-opened={`${this.isOpen}`}><ArrowIcon /></span>
            <span class="indicator-icon" data-opened={`${this.isOpen}`}></span>
          </a>
         <zpr-dropdown
          class="nav-dropdown"
          has-subnav={this.hasSubnav}
          offset={{top: 16, left: (window.innerWidth - 1050) /2 }}
          is-fixed-position={true}
          ref={el => this._dropdownElement = el}
          maxWidth={1050} anchor={this._anchor}
          is-open-with-hover={this.isOpenWithHover}>
          <slot name="body"></slot>
        </zpr-dropdown>
      </Host>
    )
  }
}